import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface ServiceCTAProps {
  title?: string;
  subtitle?: string;
  primaryButtonText?: string;
  primaryButtonLink?: string;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
  serviceType?: string;
  gradient?: string;
}

export function ServiceCTA({
  title,
  subtitle,
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
  serviceType,
  gradient = 'from-blue-600 via-blue-700 to-blue-900',
}: ServiceCTAProps) {
  const { t } = useTranslation(['services', 'common']);

  const displayTitle = title || (serviceType ? t(`services:${serviceType}.cta.title`) : '');
  const displaySubtitle = subtitle || (serviceType ? t(`services:${serviceType}.cta.subtitle`) : '');
  const displayPrimaryText = primaryButtonText || (serviceType ? t(`services:${serviceType}.cta.findButton`) : 'Find a Pro');
  const displayPrimaryLink = primaryButtonLink || (serviceType ? `/search?type=${serviceType}` : '/search');
  const displaySecondaryText = secondaryButtonText || t('common:listYourBusiness');
  const displaySecondaryLink = secondaryButtonLink || '/signup';

  return (
    <section className={`py-16 bg-gradient-to-r ${gradient}`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {displayTitle && (
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
            {displayTitle}
          </h2>
        )}
        {displaySubtitle && (
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            {displaySubtitle}
          </p>
        )}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to={displayPrimaryLink}
            className="btn bg-white text-gray-900 hover:bg-gray-100 px-8 py-4 text-lg font-semibold"
          >
            {displayPrimaryText}
          </Link>
          <Link
            to={displaySecondaryLink}
            className="btn bg-white/20 text-white hover:bg-white/30 px-8 py-4 text-lg"
          >
            {displaySecondaryText}
          </Link>
        </div>
      </div>
    </section>
  );
}
